import React from "react";
// components
import FormRequest from "../../components/FormRequest";
// styles
import styles from "./forms.module.css";

export default function Wastage() {
  const submissionMessage =
    "Form submitted! \nYour request has been received. Once eligibility criteria has been verified, you will receive an email with instructions to complete the GIAPREZA (angiotensin II) Certificate of Destruction Form. Thank you.";
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        GIAPREZA (angiotensin II) Wastage Product Replacement Form
      </h2>
      <FormRequest
        dateField={{ name: "mixedDate", label: "Date of GIAPREZA wastage" }}
        formName={"wastage_replacement_form"}
        formNameReadable={"Wastage Product Replacement Program"}
        formPageName="wastage"
        submissionMessage={submissionMessage}
      />
    </div>
  );
}
